import * as React from 'react';
import { useSelector } from 'react-redux';
import { ReduxState } from 'ducks';
import { Result } from './Result';
import styles from './PinList.module.css';
import { PageContainer } from '../Components/PageContainer';

export const PinList = () => {
  const digitalMap = useSelector((state: ReduxState) => state.universal.digitalMap.map);

  if (!digitalMap?.pins) {
    return null;
  }

  return (
    <PageContainer style={{ zIndex: 'auto' }}>
      <div className={styles['list']}>
        {digitalMap.pins.map((pin) => (
          <div key={pin.index} className={styles['item']}>
            <Result pin={pin} />
          </div>
        ))}
      </div>
    </PageContainer>
  );
};
